export default __webpack_public_path__ + "static/logo-340x52-771735b879b048f00b82c533306e82c0.png";